import React from 'react';
import styled from 'styled-components';
import { Button } from '@snsw/react-component-library';

const IconContainer = styled.div`
  margin-right: 0.5em;
`;

const IconLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ConfirmationPageButton = (props) => (
  <Button {...props}>
    {props.icon ? (
      <IconLabel>
        <IconContainer>{props.icon}</IconContainer>
        <div>{props.label}</div>
      </IconLabel>
    ) : (
      props.label
    )}
  </Button>
);
